//Proofed
import { COLOR_PRIMARY, COLOR_TERTIARY, COLOR_QUATERNARY, COLOR_SECONDARY } from '../theme'
import { REVIEWS_URL } from './common'

export interface StatCard {
    stat: string
    label: string
    detail: string
    color: string
    href?: string
}

export const defaultStats: StatCard[] = [
    { stat: '20+ yrs', label: 'Public Sector Sales Experience', detail: 'The team behind CFP has sold £2Bn+ into UK Government', color: COLOR_TERTIARY },
    { stat: '5.0 ★', label: 'Reviews.io Rating', detail: '52 reviews · 100% recommend', color: COLOR_PRIMARY, href: REVIEWS_URL },
    { stat: '100%', label: 'Coverage', detail: 'All UK & Ireland public sector tenders in one place', color: COLOR_QUATERNARY },
    { stat: 'One Email', label: 'Daily Workflow', detail: 'One morning email with your opportunities perfect for your business', color: COLOR_SECONDARY },
]

export const bullets = [
    'Built by sales professionals with decades of UK Government experience',
    'Designed for busy teams. Set up once, benefit every day',
    'Support-led onboarding with a real person to guide you',
    'We take an honest, ethical approach focused on improving your execution, not relying on luck',
]
